// extracted by mini-css-extract-plugin
export default {"footerContainer":"form-footer_footerContainer__WVJEC","line":"form-footer_line__MGmN3","buttonContainer":"form-footer_buttonContainer__AMvF4"};